module.exports = __webpack_public_path__ + "static/media/CIMG6690.b92a322d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_bei_den_Umzuegen/CIMG6690.jpg
// module id = 426
// module chunks = 0